import PropTypes from "prop-types";
import { useGetAppDownloadUrl } from "@template/utils/hooks/useGetAppDownloadUrl";
import Button from "../Button";

const DownloadAppButton = ({
  ctaRef,
  defaultStoreUrl,
  trackingCallback,
  children,
  classes,
  theme,
  ...rest
}) => {
  const { appDownloadUrl, isLoading } = useGetAppDownloadUrl({
    ctaRef,
    defaultStoreUrl
  });

  if (isLoading || !appDownloadUrl) return null;

  return (
    <Button
      href={String(appDownloadUrl)}
      onClick={trackingCallback}
      classes={classes}
      theme={theme}
      {...rest}
    >
      {children}
    </Button>
  );
};

DownloadAppButton.propTypes = {
  ctaRef: PropTypes.string,
  defaultStoreUrl: PropTypes.string.isRequired,
  trackingCallback: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.string,
  theme: PropTypes.string
};

export default DownloadAppButton;
